import React, { VFC } from 'react';

import { cn } from '../../../lib/css/className/className';
import './Tick.css';
import { CheckboxSize } from '../types';

const cnTick = cn('CheckboxTick');

export type TickProps = {
    size: CheckboxSize;
    isIndeterminate?: boolean;
    className?: string;
};

export const Tick: VFC<TickProps> = function Tick({ size, isIndeterminate, className }) {
    const svgClassName = cnTick(null, [className]);
    switch (size) {
        case 'l':
            return (
                <svg
                    className={svgClassName}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {isIndeterminate ? (
                        <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor" />
                    ) : (
                        <path
                            d="M10.6154 13.8915L7.55542 10.5865C7.39357 10.4126 7.16956 10.3098 6.93222 10.3005C6.69489 10.2911 6.46347 10.3759 6.28842 10.5365C6.20208 10.6157 6.13222 10.7111 6.08285 10.8174C6.03349 10.9237 6.00559 11.0386 6.00076 11.1557C5.99593 11.2727 6.01426 11.3896 6.0547 11.4996C6.09514 11.6095 6.1569 11.7104 6.23642 11.7965L10.5914 16.5005L17.7524 9.00748C17.8333 8.92285 17.8967 8.8231 17.939 8.71392C17.9813 8.60475 18.0017 8.4883 17.9989 8.37125C17.9961 8.25421 17.9702 8.13886 17.9228 8.03182C17.8754 7.92478 17.8073 7.82816 17.7224 7.74748C17.55 7.58353 17.3196 7.49463 17.0817 7.50025C16.8439 7.50587 16.6179 7.60557 16.4534 7.77748L10.6154 13.8915Z"
                            fill="currentColor"
                        />
                    )}
                </svg>
            );
        case 'm':
            return (
                <svg
                    className={svgClassName}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {isIndeterminate ? (
                        <rect x="5" y="9" width="10" height="2" rx="1" fill="currentColor" />
                    ) : (
                        <path
                            d="M8.61542 12.391L5.55542 9.08599C5.39357 8.91216 5.16956 8.80935 4.93222 8.79998C4.69489 8.79062 4.46347 8.87545 4.28842 9.03599C4.20208 9.11519 4.13222 9.21065 4.08285 9.31691C4.03349 9.42317 4.00559 9.53813 4.00076 9.65519C3.99593 9.77226 4.01426 9.88912 4.0547 9.99909C4.09514 10.1091 4.1569 10.21 4.23642 10.296L8.59142 15L15.7524 7.50699C15.8333 7.42237 15.8967 7.32261 15.939 7.21343C15.9813 7.10426 16.0017 6.98781 15.9989 6.87077C15.9961 6.75372 15.9702 6.63837 15.9228 6.53133C15.8754 6.4243 15.8073 6.32767 15.7224 6.24699C15.55 6.08304 15.3196 5.99414 15.0817 5.99976C14.8439 6.00539 14.6179 6.10508 14.4534 6.27699L8.61542 12.391Z"
                            fill="currentColor"
                        />
                    )}
                </svg>
            );
        case 'xs':
            return (
                <svg
                    className={svgClassName}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {isIndeterminate ? (
                        <rect x="4" y="7" width="8" height="2" rx="1" fill="currentColor" />
                    ) : (
                        <path
                            d="M4.5 7.75L7 10.25L11.5 5.75"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    )}
                </svg>
            );
        case '2xs':
            return (
                <svg
                    className={svgClassName}
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {isIndeterminate ? (
                        <rect x="3" y="5" width="6" height="2" rx="1" fill="currentColor" />
                    ) : (
                        <path
                            d="M3.25 5.75L5.25 7.75L8.75 4.25"
                            stroke="currentColor"
                            strokeWidth="1.7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    )}
                </svg>
            );
    }
};
